export default __webpack_public_path__ + "static/media/instituteDashboard.8c4ed3e5.svg";